// frontend/src/components/MobileFooterNav.js

import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  CalendarCheck,
  House,
  PlusCircle,
  MagnifyingGlass,
} from "phosphor-react";
import logoRings from "../assets/third-place-logo4.png";

export default function MobileFooterNav({ redirectAllTo = null }) {
  const { pathname } = useLocation();

  const isActive = (p) =>
    !redirectAllTo && pathname.startsWith(p);

  const navTarget = (path) =>
    redirectAllTo || path;

  const navItemClass =
    "w-12 h-12 rounded-md flex items-center justify-center";

  const iconWrapClass =
    "w-6 h-6 flex items-center justify-center shrink-0";

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-blue-50 backdrop-blur border-t border-blue-50 md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="h-14 max-w-7xl mx-auto px-6 md:px-10 xl:px-16 flex items-center justify-between">
        {/* HOME */}
        <Link
          to={navTarget("/home")}
          className={`${navItemClass} ${
            isActive("/home") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-label="Home"
        >
          <span className={iconWrapClass}>
            <House size={24} weight={isActive("/home") ? "fill" : "regular"} />
          </span>
        </Link>

        {/* SEARCH */}
        <Link
          to={navTarget("/search")}
          className={`${navItemClass} ${
            isActive("/search") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-label="Search"
        >
          <span className={iconWrapClass}>
            <MagnifyingGlass
              size={24}
              weight={isActive("/search") ? "fill" : "regular"}
            />
          </span>
        </Link>

        {/* CIRCLES */}
        <Link
          to={navTarget("/groups")}
          className={navItemClass}
          aria-label="Circles"
        >
          <span className={iconWrapClass}>
            <img
              src={logoRings}
              alt="Third Place Logo"
              className="w-6 h-6 object-contain block"
              style={{
                filter: isActive("/groups")
                  ? "brightness(0) saturate(100%) invert(28%) sepia(96%) saturate(2785%) hue-rotate(204deg) brightness(97%) contrast(94%)"
                  : "brightness(0)",
                opacity: isActive("/groups") ? 1 : 0.75,
              }}
            />
          </span>
        </Link>

        {/* UPLOAD */}
        <Link
          to={navTarget("/uploadactivity")}
          className={`${navItemClass} ${
            isActive("/uploadactivity") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-label="Upload Activity"
        >
          <span className={iconWrapClass}>
            <PlusCircle
              size={24}
              weight={isActive("/uploadactivity") ? "fill" : "regular"}
            />
          </span>
        </Link>

        {/* PLAN */}
        <Link
          to={navTarget("/plan")}
          className={`${navItemClass} ${
            isActive("/plan") ? "text-blue-600" : "text-gray-700"
          }`}
          aria-label="Plan"
        >
          <span className={iconWrapClass}>
            <CalendarCheck
              size={24}
              weight={isActive("/plan") ? "fill" : "regular"}
            />
          </span>
        </Link>
      </div>
    </nav>
  );
}